<script>
/**
 * 首页「10 个教训」卡片（自 vancheen-b2b 的 LessonCard.vue 移植为 Vue 2 版本）
 * 注意：真实 DOM 为 h3 + div.detail + div.help（<p> 不能包含块级元素），
 * 这里直接按真实 DOM 渲染。
 */
import asset from '../nh-asset'
import { t } from '../nh-i18n'

export default {
  name: 'NhLessonCard',
  props: {
    lesson: { type: Object, required: true },
    delay: { type: [Number, String], default: undefined }
  },
  computed: {
    warnIcon() {
      return asset('warn.png')
    },
    solveIcon() {
      return asset('solve.png')
    },
    whatClass() {
      return this.lesson.whatClass || 'detail'
    }
  },
  methods: {
    t
  }
}
</script>

<template>
  <div v-reveal="delay" class="feature">
    <h3>{{ lesson.title }}</h3>

    <div :class="whatClass">
      <span class="detail-label">
        <img class="feature-img" :src="warnIcon" alt="warning">{{ t('lesson.what') }}
      </span>{{ lesson.what }}
    </div>

    <div class="help">
      <span class="help-label">
        <img class="feature-img" :src="solveIcon" alt="solution">{{ t('lesson.help') }}
      </span>{{ lesson.help }}
    </div>
  </div>
</template>
